import { clampValue } from "./HeroMusicUtils";

export const TAU = Math.PI * 2;
export const FRONT_ANGLE = Math.PI / 2;

const OVERLAY_SIDE_FADE_ANGLE = Math.PI / 8;

export function getRotationForIndex(index: number, count: number) {
  return -(index / count) * TAU;
}

export function getRotationIndexFromRotation(rotation: number, count: number) {
  if (!Number.isFinite(rotation) || count <= 0) return 0;

  return (-rotation / TAU) * count;
}

export function getOverlayAngle(rotationY: number, positionIndex: number, count: number, coverAngleOffset: number) {
  return (positionIndex / count) * TAU + FRONT_ANGLE + coverAngleOffset - rotationY;
}

export function getOverlayOpacity(angle: number) {
  const distanceFromFront = Math.abs(getShortestAngleDistance(angle, FRONT_ANGLE));
  const progress = clampValue(1 - distanceFromFront / OVERLAY_SIDE_FADE_ANGLE, 0, 1);
  const opacity = progress * progress * (3 - 2 * progress);

  return opacity * opacity * opacity;
}

export function getShortestAngleDistance(from: number, to: number) {
  let diff = from - to;

  while (diff > Math.PI) diff -= TAU;
  while (diff < -Math.PI) diff += TAU;

  return diff;
}

export function getInversePerspectiveScale(overlayPerspective: number, z: number) {
  return Math.max(0.01, (overlayPerspective - z) / overlayPerspective);
}

export function roundOverlayValue(value: number) {
  return Math.round(value * 100) / 100;
}
